import {css, StyleSheet} from 'aphrodite';
import React, {useState} from 'react';
import {NodeProps} from 'reactflow';

import {EntityMapEntityNodeOrInaccessibleInfoNode} from 'graphql-client/__generated/graphqlGlobalTypes';
import {isInaccessible} from 'graphql-client/InaccessibleInfo';
import getTestProps from 'test/lib/cypress/getTestProps';
import BioentityChip from 'ui-library/chips/BioentityChip';
import {ChipSize} from 'ui-library/chips/Chip';
import NoAccessChip from 'ui-library/chips/NoAccessChip';
import {InvisibleNodeHandle} from 'ui-library/reactflow/handles/InvisibleNodeHandle';
import {
  NODE_HEADER_STYLES,
  NODE_STYLES,
  NODE_WRAPPER_STYLES,
  noDragClass,
} from 'ui-library/reactflow/nodes/BenchlingNode/BenchlingNodeDesignConstants';
import {NodeHandleProps} from 'ui-library/reactflow/nodes/BenchlingNode/BenchlingNodeTypes';

function EntityNodeHandle(props: NodeHandleProps): JSX.Element {
  if (props.handleType === 'target') {
    return <InvisibleNodeHandle nodeId={props.nodeId} handleType="target" />;
  }
  if (props.handleType === 'source') {
    return <InvisibleNodeHandle nodeId={props.nodeId} handleType="source" />;
  }
  return <></>;
}

function EntityNodeHeader(props: EntityMapEntityNodeOrInaccessibleInfoNode): JSX.Element {
  if (isInaccessible(props)) {
    return <NoAccessChip size={ChipSize.SMALL} />;
  }
  return (
    <>
      <BioentityChip
        id={props.id}
        size={ChipSize.SMALL}
        className={css(ENTITY_NODE_HEADER_CHIP_STYLES.chip)}
      />
      {props.schemaName ? <div>{props.schemaName}</div> : null}
    </>
  );
}

/**
 * Renders a node within the entity map for the given entity.
 */
export default function EntityNode(props: NodeProps<EntityMapEntityNodeOrInaccessibleInfoNode>): JSX.Element {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <div
      className={css(
        NODE_WRAPPER_STYLES.benchlingNode,
        NODE_HEADER_STYLES.nodeHeader,
        NODE_HEADER_STYLES.nodeHeaderWithNoContentBelow,
        isHovered && NODE_STYLES.hoverBorder,
        isHovered && NODE_STYLES.nodeHovered
      )}
      onMouseEnter={() => {
        setIsHovered(true);
      }}
      onMouseLeave={() => {
        setIsHovered(false);
      }}
      {...getTestProps({
        component: 'EntityNode',
        element: 'root',
      })}
    >
      <EntityNodeHeader {...props.data} />
      <div className={noDragClass()}>
        <EntityNodeHandle nodeId={props.id} handleType="source" />
      </div>
      <div className={noDragClass()}>
        <EntityNodeHandle nodeId={props.id} handleType="target" />
      </div>
    </div>
  );
}

const ENTITY_NODE_HEADER_CHIP_STYLES = StyleSheet.create({
  chip: {
    marginRight: '0px',
  },
});
